module.exports = __webpack_public_path__ + "025f324b4b43fd1e0a6a5d172b48bea9.MP3";